import React, { FunctionComponent, useState } from "react";
import styles from "./styles.module.scss";
import { Card, List, ListItemButton, ListItemIcon, ListItemText, useTheme } from "@mui/material";
import { attributeIconMap, AttributeUtilities } from "../../../models/AttributeUtilities";
import { useIsMobile } from "../../../hooks/isMobile";
import { Icon } from "../../../icons";
import { PiperDivider } from "../../PiperDivider";

export const AttributeList: FunctionComponent<IAttributeListProps> = ({ onAttributeSelected }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const [selectedAttributeType, setSelectedAttributeType] = useState<AttributeType>();
  const attributes = [
    [
      AttributeType.ARTISTS,
      AttributeType.LABELS,
      AttributeType.ALBUM_FORMATS,
      AttributeType.ALBUM_TYPES,
      AttributeType.ORIGIN_COUNTRIES,
      AttributeType.TAGS,
      AttributeType.STORES
    ],
    [AttributeType.SELL_VALUES, AttributeType.EXCHANGE_RATES],
    [AttributeType.SLEEVE_GRADES, AttributeType.MEDIA_GRADES, AttributeType.IMPACTS]
  ];
  return (
    <List
      disablePadding
      className={styles.mainList}
      sx={{ backgroundColor: theme.palette.background.default }}
    >
      {attributes.map((section, index) => (
        <Card key={index} className={isMobile ? styles.listCard : styles.listCardWide}>
          {section.map((attributeType, index) => (
            <div key={attributeType.valueOf()}>
              <ListItemButton
                className={styles.listItem}
                selected={selectedAttributeType == attributeType}
                onClick={() => {
                  setSelectedAttributeType(attributeType);
                  onAttributeSelected(attributeType);
                }}
              >
                <ListItemIcon>
                  <Icon type={attributeIconMap[attributeType]} />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  className={styles.title}
                  primary={AttributeUtilities.getAttributeTitle(attributeType)}
                  sx={{ color: theme.palette.primary.main }}
                />
              </ListItemButton>
              {index + 1 < section.length && <PiperDivider />}
            </div>
          ))}
        </Card>
      ))}
    </List>
  );
};

export interface IAttributeListProps {
  onAttributeSelected: (attribute: AttributeType) => void;
}

export enum AttributeType {
  ARTISTS,
  STORES,
  LABELS,
  SLEEVE_GRADES,
  MEDIA_GRADES,
  SELL_VALUES,
  ALBUM_FORMATS,
  ALBUM_TYPES,
  IMPACTS,
  EXCHANGE_RATES,
  TAGS,
  ORIGIN_COUNTRIES,
  GEAR_ITEMS,
  EQUIPMENTS
}
